import { useEffect } from 'react';

interface SchemaOrgProps {
  type: 'Organization' | 'WebSite' | 'LocalBusiness' | 'FAQPage';
  data: Record<string, any>;
}

export function SchemaOrg({ type, data }: SchemaOrgProps) {
  useEffect(() => {
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify({
      '@context': 'https://schema.org',
      '@type': type,
      ...data,
    });
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, [type, data]);

  return null;
}

export const organizationSchema = {
  name: 'Talleres Lujambio',
  url: import.meta.env.VITE_SITE_URL || 'https://www.tallereslujambio.com',
  logo: `${import.meta.env.VITE_SITE_URL || 'https://www.tallereslujambio.com'}/vite.svg`,
  description: 'Empresa líder en mecanizado industrial, equilibrado, enderezado y construcción mecánica con casi 50 años de experiencia en Hernani, Gipuzkoa.',
  address: {
    '@type': 'PostalAddress',
    streetAddress: 'Polígono Industrial Eziago 35, Parcela 16',
    addressLocality: 'Hernani',
    addressRegion: 'Gipuzkoa',
    postalCode: '20120',
    addressCountry: 'ES',
  },
  geo: {
    '@type': 'GeoCoordinates',
    latitude: 43.2667,
    longitude: -1.9833,
  },
  telephone: '+34943554787',
  email: 'info@tallereslujambio.com',
  sameAs: [
    'https://es.linkedin.com/company/tallereslujambio',
  ],
  areaServed: {
    '@type': 'GeoCircle',
    geoMidpoint: {
      '@type': 'GeoCoordinates',
      latitude: 43.2667,
      longitude: -1.9833,
    },
    geoRadius: '100000',
  },
};

export const localBusinessSchema = {
  ...organizationSchema,
  '@type': 'LocalBusiness',
  priceRange: '€€€',
  openingHoursSpecification: [
    {
      '@type': 'OpeningHoursSpecification',
      dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
      opens: '08:00',
      closes: '17:00',
    },
  ],
};

export const websiteSchema = {
  '@type': 'WebSite',
  name: 'Talleres Lujambio',
  url: import.meta.env.VITE_SITE_URL || 'https://www.tallereslujambio.com',
  description: 'Talleres Lujambio - Mecanizado industrial, equilibrado, enderezado y construcción mecánica en Hernani, Gipuzkoa',
  inLanguage: 'es-ES',
  publisher: {
    '@type': 'Organization',
    name: 'Talleres Lujambio',
    logo: {
      '@type': 'ImageObject',
      url: `${import.meta.env.VITE_SITE_URL || 'https://www.tallereslujambio.com'}/vite.svg`,
    },
  },
};
